import { IsAuthLoaded } from '../core/guards/auth.guards';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanSignInRoute } from '../core/guards/auth.guards';


const routes: Routes = [
  {
    path: 'error',
    loadChildren: () => import('../pages/boot-module/error-page/error-page.module').then(m => m.ErrorPageModule)
  },
  {
    path: 'fans',
    loadChildren: () => import('../pages/fanclub/fanclub.module').then(m => m.FanclubModule)
  },
  {
    path: 'legal',
    loadChildren: () => import('../pages/boot-module/legal-page/legal-page.module').then(m => m.LegalPageModule)
  },
  {
    path: 'directlink',
    loadChildren: () => import('../pages/directlink/directlink.module').then(m => m.DirectlinkModule)
  },
  {
    path: 'mailing',
    loadChildren: () => import('../pages/mailing/mailing-actions-page/mailing-actions-page.module').then(m => m.MailingActionsPageModule)
  },

  {
    path: 'public',
    loadChildren: () => import('../pages/public/public.module').then(m => m.PublicModule)
  },

  {
    path: 'signin',
    canActivate: [IsAuthLoaded, CanSignInRoute],
    loadChildren: () => import('../pages/boot-module/signin-page/signin-page.module').then(m => m.SigninPageModule)
  },
  {
    path: 'start',
    loadChildren: () => import('../pages/home/home.module').then(m => m.HomeModule)
  },

  {
    path: 'offline',
    loadChildren: () => import('../pages/offline/offline.module').then(m => m.OfflineModule)
  },
  {
    path: '', loadChildren: () => import('../core/core.module').then(m => m.CoreModule)
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    enableTracing: false,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class BootRoutingModule { }
